<template>
  <div>
    <div class="Fuell-Toolbar justify-content-between">
      <button
        @click="showCustomersFilterModal"
        class="Fuell-ToolbarButton"
      >
        <span class="Fuell-ToolbarButton--icon">
          <img
            :src="require('@/assets/img/icons/icon-filter.svg')"
            alt="filter"
          />
        </span>
        <span class="Fuell-ToolbarButton--label">
          {{ $t('FILTERS') }}
        </span>
        <span
          class="Fuell-ToolbarButton--badge"
          v-if="filtersAmount"
          aria-hidden="true"
        >
          {{ filtersAmount }}
        </span>
      </button>
      <span
        class="Fuell-ToolbarButton remove-container"
        v-if="filtersAmount > 0"
        @click.prevent.stop="resetFilters"
      >
        <inline-svg
          style="height:10px;"
          :src="require('@/assets/img/icons/close-menu.svg')"
          alt="remove-filters"
        />
      </span>
      <div class="d-flex ml-auto">
        <button
          class="Fuell-ToolbarButton blue"
          :disabled="isCallingZoho"
          @click="updateCustomerTypes"
        >
          <span
            class="Fuell-ToolbarButton--label"
            v-t="{path:'customer_update_customer_types'}"
          >
          </span>
        </button>
        <button
          class="Fuell-ToolbarButton ml-2 blue"
          @click="showNewCustomerModal"
          data-modal="NewUserModal"
          data-overlay="true"
        >
          <span
            class="Fuell-ToolbarButton--label"
            v-t="{path:'customer_creation_invite_customer'}"
          >
          </span>
        </button>
      </div>
    </div>
    <user-customer-list-table @showCustomerActionsModal="showActionsModal"></user-customer-list-table>
    <customer-actions-modals
      v-if="showActionsModalFlag"
      :open.sync="showActionsModalFlag"
      :customerId="customer.id"
      @showBillingModal="showBillingModal"
      @showConfirmToggleCustomerStatusModal="showConfirmToggleCustomerStatusModal"
      @showFundsTransferModal="showCustomerFundsTransferModal"
      @showTransferModal="showCustomerTransferModal"
      @showEditAddressModal="showCustomerEditAddressModal"
      @showEditFiscalAddressModal="showCustomerEditFiscalAddressModal"
    />
    <new-customer-modal
      v-if="showNewCustomerModalFlag"
      :open.sync="showNewCustomerModalFlag"
      @closeModal="handleCloseModal"
    />
    <customer-billing-modal
      v-if="showCustomerBillingModalFlag"
      :open.sync="showCustomerBillingModalFlag"
      :customer="customer"
      @closeModal="handleCloseModal"
    ></customer-billing-modal>
    <customer-funds-transfer-modal
      v-if="showCustomerFundsTransferModalFlag"
      :customer="customer"
      :open.sync="showCustomerFundsTransferModalFlag"
      @closeModal="handleCloseModal"
    />
    <customer-transfer-modal
      v-if="showCustomerTransferModalFlag"
      :customer="customer"
      :open.sync="showCustomerTransferModalFlag"
      @closeModal="handleCloseModal"
    />
    <confirm-modal
      v-if="showConfirmToggleCustomerStatusModalFlag"
      :id="'confirm-customer-toggle-status'"
      :open.sync="showConfirmToggleCustomerStatusModalFlag"
      :title="customerToggleActivationHeaderActionLabel"
      :message="''"
      ignoreDefaultMessage
      :acceptText="customerToggleActivationHeaderActionLabel"
      :dismissText="'ACTION_CANCEL'"
      @accept="toggleCustomerStatus"
      @dismissCancel="hideConfirmToggleCustomerStatusModal"
    >
      <template
        v-slot:additional
        :extraInfo="customer.name"
      >
        <i18n
          tag="span"
          :path="customerToggleActivationConfirmTextLabel"
        >
          <template v-slot:customerName>
            <span class="text-primary">{{customer.name}}</span>
          </template>
        </i18n>
      </template>
    </confirm-modal>
    <customer-filters-modal
      :open.sync="showCustomerFiltersModalFlag"
      v-if="showCustomerFiltersModalFlag"
      @resetCustomerFilters="fetchCustomers"
      @closeModal="handleCloseModal"
    />
    <customer-edit-address-modal
      v-if="showCustomerEditAddressModalFlag"
      :customer="customer"
      :open.sync="showCustomerEditAddressModalFlag"
      @closeModal="handleCloseModal"
    />
    <customer-edit-fiscal-address-modal
      v-if="showCustomerEditFiscalAddressModalFlag"
      :customer="customer"
      :open.sync="showCustomerEditFiscalAddressModalFlag"
      @closeModal="handleCloseModal"
    />

  </div>
</template>

<script>
import InlineSvg from 'vue-inline-svg'
import UserCustomerListTable from '../../_components/active/UserCustomerListTable'

const CustomerActionsModals = () => import('../../_components/_shared/CustomerActionsModal')
const NewCustomerModal = () => import('../../_components/signup/CustomerNewCustomerModal')
const CustomerBillingModal = () => import('../../_components/active/CustomerBillingModal')
const ConfirmModal = () => import('@/components/Commons/ConfirmModal')
const CustomerFundsTransferModal = () => import('../../_components/active/CustomerFundsTransferModal')
const CustomerTransferModal = () => import('../../_components/active/CustomerTransferModal')
const CustomerFiltersModal = () => import('../../_components/_shared/CustomerFiltersModal')
const CustomerEditAddressModal = () => import('../../_components/active/CustomerEditAddressModal')
const CustomerEditFiscalAddressModal = () => import('../../_components/active/CustomerEditFiscalAddresModal')

export default {
  name: 'CustomerList',
  components: {
    UserCustomerListTable,
    CustomerActionsModals,
    NewCustomerModal,
    CustomerBillingModal,
    CustomerFundsTransferModal,
    CustomerTransferModal,
    ConfirmModal,
    CustomerFiltersModal,
    InlineSvg,
    CustomerEditAddressModal,
    CustomerEditFiscalAddressModal
  },
  data () {
    return {
      showActionsModalFlag: false,
      showNewCustomerModalFlag: false,
      showCustomerBillingModalFlag: false,
      showConfirmToggleCustomerStatusModalFlag: false,
      showCustomerFundsTransferModalFlag: false,
      showCustomerTransferModalFlag: false,
      showCustomerFiltersModalFlag: false,
      showCustomerEditAddressModalFlag: false,
      showCustomerEditFiscalAddressModalFlag: false,
      customer: {},
      isCallingZoho: false
    }
  },
  methods: {
    handleCloseModal () {
      this.showNewCustomerModalFlag = false
      this.showCustomerBillingModalFlag = false
      this.showConfirmToggleCustomerStatusModalFlag = false
      this.showCustomerFundsTransferModalFlag = false
      this.showCustomerTransferModalFlag = false
      this.showCustomerFiltersModalFlag = false
      this.showCustomerEditAddressModalFlag = false
      this.showCustomerEditFiscalAddressModalFlag = false
    },
    async updateCustomerTypes () {
      this.isCallingZoho = true
      await this.$store.dispatch('ConfigStore/fetchZohoPlans')
      this.isCallingZoho = false
    },
    showActionsModal (event) {
      this.customer = event
      this.showActionsModalFlag = true
    },
    showNewCustomerModal () {
      this.showNewCustomerModalFlag = true
    },
    showBillingModal (event) {
      this.showCustomerBillingModalFlag = true
    },
    showConfirmToggleCustomerStatusModal (event) {
      this.customer = event
      this.showConfirmToggleCustomerStatusModalFlag = true
    },
    hideConfirmToggleCustomerStatusModal () {
      this.showConfirmToggleCustomerStatusModalFlag = false
    },
    showCustomerFundsTransferModal (event) {
      this.customer = event
      this.showCustomerFundsTransferModalFlag = true
    },
    showCustomerTransferModal (event) {
      this.customer = event
      this.showCustomerTransferModalFlag = true
    },
    showCustomerEditAddressModal (event) {
      this.customer = event
      this.showCustomerEditAddressModalFlag = true
      this.showCustomerEditFiscalAddressModalFlag = false
    },
    showCustomerEditFiscalAddressModal (event) {
      this.customer = event
      this.showCustomerEditFiscalAddressModalFlag = true
      this.showCustomerEditAddressModalFlag = false
    },
    toggleCustomerStatus () {
      if (this.customer && this.customer.customerStatus && this.customer.customerStatus.code === 'ACTIVE') {
        this.$store.dispatch('CustomersStore/archiveCustomer', this.customer.id)
      } else {
        this.$store.dispatch('CustomersStore/activateCustomer', this.customer.id)
      }
    },
    showCustomersFilterModal () {
      this.showCustomerFiltersModalFlag = true
    },
    fetchCustomers () {
      this.$store.dispatch('CustomersStore/clearCustomers')
      this.$store.dispatch('CustomersStore/setCustomersFilters', {})
    },
    resetFilters () {
      this.fetchCustomers()
    }

  },
  computed: {
    customerToggleActivationHeaderActionLabel () {
      return this.customer && this.customer.customerStatus && this.customer.customerStatus.code === 'ACTIVE' ? 'customers_confirm_archive_header_action' : 'customers_confirm_activate_header_action'
    },
    customerToggleActivationConfirmTextLabel () {
      return this.customer && this.customer.customerStatus && this.customer.customerStatus.code === 'ACTIVE' ? 'customers_confirm_toggle_archive_customer_status' : 'customers_confirm_toggle_activate_customer_status'
    },
    customerFilters () {
      return this.$store.getters['CustomersStore/filters']
    },
    filtersAmount () {
      let amount = 0
      Object.keys(this.customerFilters).forEach(filter => {
        if (filter === 'creationType.code') {
          amount++
        }
      })
      return amount
    }
  }
}
</script>
